import styled from 'styled-components';
import { media } from '../../../../styles/themes/constants';

export const LayoutMaster = styled.div`
  height: 100vh;
  background: transparent;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const LayoutMain = styled.div`
  background: transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 8px;

  @media (max-width: 767px) {
    padding: 0 4px;
  }
  
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 0 10px;
  }
  
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  
  @media (min-width: 1400px) {
    padding: 0 32px;
  }
`;

export const TopSpacer = styled.div`
  height: 0px;
  background: transparent;
`;

export const ContentContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
`;

export const MobileOverlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  @media only screen and ${media.md} {
    display: none;
  }
`;
